import { createPhasedAction } from 'redux/actionCreators'

export const { setLiveChatAction } = createPhasedAction('SET_LIVE_CHAT_ACTION')
